import { PageBody } from '../components/shell/PageBody.tsx';
import '../features/onboarding/command.ts';
import { GettingStarted } from '../features/onboarding/GettingStarted.tsx';

/** Getting started: the first ten minutes, one step at a time (features/onboarding). */
export default function GettingStartedPage() {
  return (
    <PageBody className="max-w-300">
      <GettingStarted />
    </PageBody>
  );
}
